import LayerSwitcher from 'ol-ext/control/LayerSwitcher';
import { infoLayer } from './layout';
import { layers } from './source';

export var lswitcher = new LayerSwitcher({
  // target:$(".layerSwitcher").get(0),
  target: $("#nav-layer-switcher").get(0),
  collapsed: false,
  reordering: false,
  show_progress: false,
  extent: true,
  oninfo: function (l) {
    infoLayer(l);
  },
});

// The serach input
var search = $('<input>').attr('placeholder', 'Wyszukaj w liście warstw');
function filterLayers(rex, layers) {
  var found = false;
  layers.forEach(function (l) {
    // Layer Group
    if (l.getLayers) {
      if (filterLayers(rex, l.getLayers().getArray())) {
        l.set('noLayer', false);
        found = true;
      } else {
        l.set('noLayer', true);
      }
    } else {

      //if (l.get('title')) {

      if (rex.test(l.get('title'))) {
        found = true;
      }
      //}

    }
  });
  return found;
}

search.on('keyup change', function () {
  var rex = new RegExp(search.val());
  filterLayers(rex, layers);
  // Force layer switcher redraw
  setTimeout(() => lswitcher.drawPanel(), 200);
});


// Add search input in the switcher header
lswitcher.setHeader(search.get(0));

// When switcher is drawn hide/show the list item according to its visility
lswitcher.on('drawlist', function (e) {
  // Hide Layer Group with no layers visible
  if (e.layer.getLayers) {
    if (e.layer.get('noLayer')) {
      $(e.li).hide();
    } else {
      $(e.li).show();
    }
  } else {
    var rex = new RegExp(search.val());
    if (rex.test(e.layer.get('title'))) {
      $(e.li).show();
    } else {
      $(e.li).hide();
    }
  }
});